module.exports = __webpack_public_path__ + "img/Participating.bc63c599.svg";